import { createFeatureSelector, createSelector } from '@ngrx/store'
import { INFOBOOTHS_FEATURE_KEY, InfoboothsState, infoboothsAdapter } from './infobooths.reducer'

export const selectInfoboothsState = createFeatureSelector<InfoboothsState>(INFOBOOTHS_FEATURE_KEY)

const { selectAll, selectEntities } = infoboothsAdapter.getSelectors()

export const selectInfoboothsLoaded = createSelector(selectInfoboothsState, (state: InfoboothsState) => state.loaded)

export const selectAllInfobooths = createSelector(selectInfoboothsState, (state: InfoboothsState) => selectAll(state))

export const selectInfoboothsEntities = createSelector(selectInfoboothsState, (state: InfoboothsState) =>
  selectEntities(state),
)

export const selectSelectedId = createSelector(selectInfoboothsState, (state: InfoboothsState) => state.selectedId)

export const selectEntity = createSelector(selectInfoboothsEntities, selectSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)

export const selectEditCreateLoaded = createSelector(
  selectInfoboothsState,
  (state: InfoboothsState) => state.editCreateLoaded,
)
